import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {OrderDetailsService} from './../shared/services/order-details/order-details.service';
import {map} from 'rxjs/internal/operators';
import {LoginService} from './../shared/services/login/login.service';
import {Order} from './../shared/contracts/order';
import {UtilityCookieService} from './../shared/utils/cookie/utilitycookie.service';
import {ResponseValidator} from '../shared/utils/response-validator';

export interface OrdersSummery {
  noOrders: boolean;
  allOrders: Order[];
  nextOrders: Order[];
  orderHistory: Order[];
}
@Injectable({
  providedIn: 'root'
})
export class OrdersResolver implements Resolve<any> {
  constructor(private _order: OrderDetailsService,
              private _auth: LoginService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): OrdersSummery | any {
      const user = this._auth.userData;
      if (user.authenticated && (user.rxTied || user.caregivee)) {
        return this._order.get(user).pipe(map(data => {
          if (new ResponseValidator(data, true)) {
            return this._order.viewOrdersData;
          } else {
            data.hasError = true;
          }
          return data;
        }, err => err));
      }
  }
}
